// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../.yarn/__virtual__/css-loader-virtual-2ae40ad6f9/0/cache/css-loader-npm-3.5.3-0f886851e6-e5fa1707d7.zip/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".master-page{display:flex;flex-direction:row;flex:1}.master-page-shrink-wrap{display:flex;flex:0.1 1 150rem;margin:0 auto}@media (max-width: 768px){.master-page{flex-direction:column;flex:1}.master-page-shrink-wrap{flex-direction:column;flex:1;margin:unset}}\n", ""]);
// Exports
module.exports = exports;
